<template>
<div>
  <p
    v-if="errors && !isError(errors)"
    class="error-list-heading elr-text-danger"
  >Please correct the following problems:</p>
  <p v-else-if="errors" class="elr-text-danger">Try again later</p>
  <p v-else class="error-list-heading elr-text-success">No Errors</p>
  <nav v-if="errors && !isError(errors)" class="error-list">
    <ul>
      <li
        :key="e"
        v-for="e in errorFields"
      >
        <span
          v-if="includes(includedFields, e)"
          class="elr-bold elr-text-danger"
        >{{errors[e][0]}}</span>
      </li>
    </ul>
  </nav>
</div>
</template>

<script>
import { includes, isError } from 'lodash';

export default {
  name: 'ErrorList',
  props: {
    errors: {
      type: [Object, Error],
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  computed: {
    errorFields() {
      return Object.keys(this.errors);
    },
    includedFields() {
      return this.fields.map(o => o.name);
    }
  },
  methods: {
    includes,
    isError
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.error-list-heading {
  font-weight: 900;
  font-size: 14px;
}

.error-list ul {
  color: $danger-color;
  margin-left: 0;
  padding-left: 0;

  li {
    font-size: 14px;
    list-style: none;
  }
}
</style>


